import { controlIcons } from '../../constants/assets'

type SearchInputProps = {
  label: string
  value: string
  placeholder?: string
  onChange: (value: string) => void
  /** Field height in px. The bookings filters use 65, the drivers filters 59. */
  height?: number
}

export const SearchInput = ({
  label,
  value,
  placeholder,
  onChange,
  height = 65,
}: SearchInputProps) => (
  <div
    style={{ height }}
    className="flex w-full items-center gap-[12px] rounded-[12px] border border-solid border-dash-field bg-white px-[18px]"
  >
    <img alt="" aria-hidden className="block size-[24px] max-w-none shrink-0" src={controlIcons.search} />
    <input
      type="search"
      aria-label={label}
      value={value}
      placeholder={placeholder}
      onChange={(event) => onChange(event.target.value)}
      className="min-w-0 flex-1 bg-transparent font-host text-[16px] font-medium leading-normal text-dash-field-text outline-none placeholder:text-dash-field-text"
    />
  </div>
)
